import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import UserCard from "./UserCard";
import { connect, registerHandler } from "../../utils/socket";
import { Select, Button } from "antd";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import { getOrganizations, getOrganizationMappings } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import Konami from "react-konami-code";


import "./OrgDashboard.css";
const { Option } = Select;

function OrgDashboard({
  store,
  dashboardStore,
  navStore,
  authStore,
  orgDashboardStore,
}) {
  const [loading, setLoading] = useState(true);
  const [organizations, setOrganizations] = useState([]);

  const navigate = useNavigate();

  const handleChange = (orgId) => {
    dashboardStore.clearSubscription();
    const org = organizations.find((x) => x.id === orgId);
    fetchDashboardData(orgId, org.name);
  };

  const socketMessageReceived = (data) => {
    const userCode = data.user_code;
    // status payload
    if (
      data.hasOwnProperty("status") ||
      data.hasOwnProperty("instanteneous_status")
    ) {
      if (data.hasOwnProperty("heart_rate")) {
        const heartrate = data["heart_rate"];
        orgDashboardStore.setHeartRate(userCode, heartrate);
      }
      if (data.hasOwnProperty("motion")) {
        const motion = data["motion"];
        orgDashboardStore.setMotion(userCode, motion);
      }
      if (data.hasOwnProperty("hrv")) {
        const hrv = data["hrv"];
        orgDashboardStore.setHrv(userCode, hrv);
      }
      if (data["status"]) {
        const status = data["status"];
        if (status["introspection"]) {
          const introspection = status["introspection"];
          const color = data["instanteneous_status"]["color"];
          if (color === "red") {
            introspection["color"] = "#F26C6C";
          }
          if (color === "yellow") {
            introspection["color"] = "#EDE408";
          }
          if (color === "green") {
            introspection["color"] = "#5AD876";
          }

          if (color === "gray") {
            introspection["color"] = "rgba(100, 100, 100, 0.4)";
          }
          orgDashboardStore.setIntrospection(userCode, introspection);
        }
        const color = status["color"];
        const label = status["label"];
        orgDashboardStore.setStatus(userCode, color);
        orgDashboardStore.setAlertLabel(userCode, label);
      }
    }
  };

  const fetchDashboardData = async (orgId, orgName) => {
    //orgStats
    //org users
    if (!authStore.user) {
      return;
    }
    dashboardStore.setOrgId(orgId);
    const organizations = await getOrganizations();
    setOrganizations(organizations);
    if (authStore.userRole !== "org_user") {
      dashboardStore.setUsers(await getOrganizationMappings(orgId));
      dashboardStore.setOrgName(orgName);
    } else {
      dashboardStore.setUsers([
        { id: authStore.user["id"], user_id: authStore.user["user_code"] },
      ]);
    }
  };

  useEffect(() => {
    connect();
    registerHandler(socketMessageReceived);
  }, []);

  useEffect(() => {
    if (!authStore || !authStore.user) {
      return;
    }
    setLoading(false);
    const orgId = authStore.user.organization_details.id;
    const orgName = authStore.user.organization_details.name;
    fetchDashboardData(orgId, orgName);
  }, [authStore.user]);

  const enableKonami = () => {
    console.log("konami");
    orgDashboardStore.setAdminMode(true);
  };
  return (
    <>
      <div className="OrgDashboard">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div>
            {authStore.userRole === "admin" && organizations.length > 0 && (
              <div>
                <h1 style={{ float: "left" }}>
                  <Select
                    defaultValue={dashboardStore.orgId}
                    style={{ width: 120 }}
                    onChange={handleChange}
                  >
                    {organizations.map((x) => (
                      <Option value={x.id}>{x.name}</Option>
                    ))}
                  </Select>
                </h1>
                <div className="clear"></div>
              </div>
            )}

            {orgDashboardStore.adminMode && (
              <Row justify="end" style={{ marginBottom: "20px" }}>
                <Col span={3} style={{ textAlign: "right" }}>
                  <Button onClick={() => navigate("/detail-chart")}>
                    Timeseries View
                  </Button>
                </Col>
                <Col span={2} style={{ textAlign: "right" }}>
                  <Button onClick={() => window.open("/simulator", "_blank")}>
                    Simulator
                  </Button>
                </Col>
                <Col span={2} style={{ textAlign: "right" }}>
                  <Button onClick={() => window.open("/rules", "_blank")}>
                    Thresholds & Rules
                  </Button>
                </Col>
              </Row>
            )}
            <Row>
              {dashboardStore.users.map((x) => {
                return (
                  <Col xs={24} md={12} sm={24} lg={12} xl={6}>
                    <UserCard
                      dashboardStore={dashboardStore}
                      orgDashboardStore={orgDashboardStore}
                      orgId={dashboardStore.orgId}
                      userCode={x.user_id}
                      key={`user-card-${x.user_id}`}
                    ></UserCard>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </div>
      <Konami action={() => enableKonami()}> </Konami>
    </>
  );
}

export default observer(OrgDashboard);
